import { PACKAGE } from '@/config/constants'
import { events$ } from '@/services'
import { EVENT_LEAD } from '@/config/events'

const mapping = {
  DEDUCTIBLE_ADJUSTED: {
    label: 'DEDUCTIBLE_ADJUSTED',
    package: PACKAGE.ERRORS,
    callback: () => {
      events$.emit(EVENT_LEAD.DEDUCTIBLE_ADJUSTED, {})
    },
  },
  HEALTH_ANSWERS_CLEARED: {
    label: 'HEALTH_ANSWERS_CLEARED',
    package: PACKAGE.ERRORS,
    callback: () => {
      events$.emit(EVENT_LEAD.HEALTH_ANSWERS_CLEARED, {})
    },
  },
}

export default mapping
